import { z } from "zod";
import {
	clockToMinutes,
	parseBreakMinutes,
	parsePercentage,
	TIME_PATTERN,
} from "../utils/schedule";

const MAX_OVERTIME_PCT = 500;

const percentageSchema = z.string().refine(
	(value) => {
		const parsed = parsePercentage(value);
		return parsed != null && parsed <= MAX_OVERTIME_PCT;
	},
	{ message: `Informe um percentual entre 0 e ${MAX_OVERTIME_PCT}` },
);

const scheduleDaySchema = z
	.object({
		weekday: z.number().int().min(0).max(6),
		enabled: z.boolean(),
		startsAt: z.string(),
		endsAt: z.string(),
		breakMinutes: z.string(),
	})
	.superRefine((day, ctx) => {
		if (!day.enabled) return;
		const start = clockToMinutes(day.startsAt);
		const end = clockToMinutes(day.endsAt);
		const breakMinutes = parseBreakMinutes(day.breakMinutes);
		if (!TIME_PATTERN.test(day.startsAt)) {
			ctx.addIssue({
				code: "custom",
				message: "Informe o início",
				path: ["startsAt"],
			});
		}
		if (!TIME_PATTERN.test(day.endsAt)) {
			ctx.addIssue({
				code: "custom",
				message: "Informe o fim",
				path: ["endsAt"],
			});
		} else if (start != null && end != null && end <= start) {
			ctx.addIssue({
				code: "custom",
				message: "O fim deve ser depois do início",
				path: ["endsAt"],
			});
		}
		if (breakMinutes == null) {
			ctx.addIssue({
				code: "custom",
				message: "Informe os minutos de intervalo",
				path: ["breakMinutes"],
			});
		} else if (start != null && end != null && breakMinutes >= end - start) {
			ctx.addIssue({
				code: "custom",
				message: "O intervalo não pode cobrir toda a jornada",
				path: ["breakMinutes"],
			});
		}
	});

export const timeSettingsSchema = z.object({
	weekdayOvertimePct: percentageSchema,
	saturdayOvertimePct: percentageSchema,
	sundayOvertimePct: percentageSchema,
	holidayOvertimePct: percentageSchema,
	schedule: z.array(scheduleDaySchema).length(7),
});

export const holidaySchema = z.object({
	date: z.date({ message: "Informe a data" }),
	name: z.string().trim().min(1, { message: "Informe o nome do feriado" }),
});

export type HolidayFormValues = z.infer<typeof holidaySchema>;
